import { render, staticRenderFns } from "./PatientHistoryItemDiagnosis.vue?vue&type=template&id=2ce23adc&scoped=true&lang=pug&"
import script from "./PatientHistoryItemDiagnosis.vue?vue&type=script&lang=js&"
export * from "./PatientHistoryItemDiagnosis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce23adc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
